import { RouteAnimation } from 'src/animations/animations';
import { NavigateFunction } from 'react-router-dom';

export const push = (
  path: string,
  navigate: NavigateFunction,
  animation?: RouteAnimation,
  state?: unknown
) => {
  navigate(path, {
    state: state ?? { animation: animation ?? RouteAnimation.Fade }
  });
};
